import React, { useState } from 'react';
import { PoolSection, METRICS, LENS, GOLD } from '../ResearchPage';

// The full scorecard, inline in the company profile. It REUSES Quorum's PoolSection (and its
// parameter → sub-parameter drill-down) so the same figures are rendered by the same code in
// both places — a reader who opens a name in Quorum and in the master view can never be shown
// two different pictures of one score. Only the modal chrome is left behind; the body is the
// same, with the same score / weight / contribution lens.
//
// ONE flat parameter list carries both levels, told apart by parent_key — split here exactly as
// ScorecardDetail does, in the single place the two levels are ever separated.

export default function ScoresPanel({ score, others }) {
  const [mode, setMode] = useState('score');
  if (!score) return null;

  const pools = Array.isArray(score.pool_scores) ? score.pool_scores : [];
  const all = Array.isArray(score.parameters) ? score.parameters : [];
  const params = all.filter((p) => p.parent_key == null);
  const subs = all.filter((p) => p.parent_key != null);

  return (
    <div>
      {/* The lens toggle — score (0–5), decision weight, or their product. */}
      <div className="mb-3 flex flex-wrap items-center gap-3">
        <div className="inline-flex rounded-lg border border-gray-200 p-0.5 text-xs dark:border-gray-800">
          {METRICS.map((mt) => (
            <button key={mt.key} type="button" onClick={() => setMode(mt.key)}
                    className="rounded-md px-2.5 py-1 font-medium transition-colors"
                    style={mode === mt.key ? { background: GOLD, color: '#111' } : { color: '#6b7280' }}>
              {mt.label}
            </button>
          ))}
        </div>
        <span className="text-[11px] text-gray-400">{LENS[mode]}</span>
      </div>

      <div className="flex flex-col gap-4">
        {pools.map((pool, i) => (
          <PoolSection key={i} pool={pool} params={params} subs={subs} mode={mode} />
        ))}
      </div>

      {/* If more than one team scored this name, say so rather than silently showing only one.
          The headline uses the latest; a second team's full card is a later addition, not a
          number we blend in without saying. */}
      {Array.isArray(others) && others.length > 0 && (
        <p className="mt-3 text-[11px] text-gray-400">
          Also scored by {others.map((o) => o.scored_by_name).filter(Boolean).join(', ')} — showing the most recent.
        </p>
      )}
    </div>
  );
}
